import type { Battery } from '../../types/models';

interface SpecSheetCardProps {
  battery: Battery;
  className?: string;
}

function chemistryLabel(chem: Battery['chemistry']): string {
  switch (chem) {
    case 'li-ion':
      return 'Lithium-Ion';
    case 'li-po':
      return 'Lithium-Polymer';
    case 'nimh':
      return 'Nickel-Metal Hydride';
    case 'lead-acid':
      return 'Lead-Acid';
  }
}

export function SpecSheetCard({ battery, className = '' }: SpecSheetCardProps) {
  const rows: Array<[string, string]> = [
    ['Model number', battery.modelCode],
    ['Battery type', chemistryLabel(battery.chemistry)],
    ['Voltage', `${battery.voltage} V`],
    ['Capacity', `${battery.capacityMah} mAh`],
  ];
  if (battery.weightG !== undefined) rows.push(['Weight', `${battery.weightG} g`]);
  if (battery.dimensionsMm) {
    rows.push([
      'Dimensions',
      `${battery.dimensionsMm.w}×${battery.dimensionsMm.h}×${battery.dimensionsMm.d} mm`,
    ]);
  }

  return (
    <div className={`panel p-5 ${className}`}>
      <div className="text-xs uppercase tracking-wide text-ink-500 mb-1">Spec sheet</div>
      <h3 className="text-lg font-semibold mb-4">{battery.modelCode}</h3>
      <dl className="flex flex-col gap-3 text-sm">
        {rows.map(([label, value]) => (
          <div
            key={label}
            className="flex items-baseline justify-between gap-4 pb-3 border-b border-ink-900/5 last:border-0 last:pb-0"
          >
            <dt className="text-ink-500">{label}</dt>
            <dd className="font-data font-semibold text-right">{value}</dd>
          </div>
        ))}
      </dl>
    </div>
  );
}
